import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3201dc24"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "company-selector flex"
}
const _hoisted_2 = ["aria-label", "onClick"]
const _hoisted_3 = { class: "company-selector_wrapper_label" }
const _hoisted_4 = {
  key: 0,
  class: "company-selector_wrapper_icon flex"
}
const _hoisted_5 = { class: "company-selector_options_inner flex" }
const _hoisted_6 = ["aria-label", "onClick"]

import {useUser} from '@/logged/features/user';
    import {computed, nextTick, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {SvgIcon} from '@/logged/common/ui';
    import {NavigationTab, useDisplayMode} from '..';
    import NavigationTabItem from './NavigationTabItem.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySelector',
  setup(__props) {

    const userStore = useUser();
    const displayModeStore = useDisplayMode();
    const {selectedIdentity, userIdentities} = storeToRefs(userStore);
    const {isDisplayModeReduced} = storeToRefs(displayModeStore);

    const isOpened = ref(false);

    const isDisabled = computed<boolean>(() => !filteredUserIdentities.value.length);

    function closePanel() {
        isOpened.value = false;
        document.documentElement.removeEventListener('click', closePanel);
    }

    const filteredUserIdentities = computed(() => userIdentities.value?.filter((f) => f.id !== userStore.selectedIdentity?.id));

    async function handleToggleSelect() {
        if (!isDisabled.value) {
            if (isOpened.value) {
                closePanel();
            } else {
                isOpened.value = true;
                await nextTick();
                document.documentElement.addEventListener('click', closePanel);
            }
        }
    }

    const computedLabel = computed<string>(() => {
        if (selectedIdentity.value) {
            return selectedIdentity.value.label;
        }
        // TODO translation
        return 'No company selected';
    });

    function handleItemClick(id: string) {
        userStore.setUserIdentity(id);
    }

    // - Reduced mode

    const reducedCompanySelectorProp = computed(
        (): NavigationTab => {
            if (userStore.selectedIdentity && userIdentities.value) {
                const childrenTabs: NavigationTab[] = filteredUserIdentities.value?.map((identity) => ({
                    id: identity.id,
                    title: identity.label,
                    action: () => userStore.setUserIdentity(identity.id),
                }));

                return {
                    id: 'switch',
                    title: userStore.selectedIdentity.label,
                    icons: {
                        mainIcon: 'aside/swap-company',
                    },
                    showTitleOnHover: true,
                    children: childrenTabs,
                };
            }
            // Display placeholder until user info is fetched
            return {
                id: 'switch',
                title: 'Select a company',
                icons: {
                    mainIcon: 'aside/swap-company',
                },
            };
        },
    );

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (!_unref(isDisplayModeReduced))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["company-selector_wrapper flex", {isOpened: isOpened.value, isDisabled: _unref(isDisabled)}]),
          "aria-label": _unref(computedLabel),
          onClick: _withModifiers(handleToggleSelect, ["stop"])
        }, [
          _createVNode(_unref(SvgIcon), {
            class: "main-icon",
            src: "aside/swap-company",
            name: "swap-company",
            active: isOpened.value
          }, null, 8, ["active"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(computedLabel)), 1)
          ]),
          (!_unref(isDisabled))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_joy_icon, {
                  name: "chevron-double",
                  color: isOpened.value ? 'blue' : 'grey'
                }, null, 8, ["color"])
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2),
        _createVNode(_Transition, { name: "fade-scale" }, {
          default: _withCtx(() => [
            (isOpened.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "company-selector_options flex",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredUserIdentities), (company) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: company.id,
                        class: _normalizeClass([{isSelected: _unref(selectedIdentity) && company.id === _unref(selectedIdentity).id}, "company-selector_options_inner_item flex"]),
                        "aria-label": company.label,
                        onClick: ($event: any) => (handleItemClick(company.id))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(company.label), 1)
                      ], 10, _hoisted_6))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(NavigationTabItem, {
        key: 1,
        class: "reduced-tab",
        tab: _unref(reducedCompanySelectorProp),
        selector: ""
      }, null, 8, ["tab"]))
}
}

})